import React from 'react';

import { TRole } from '@src/types/course';
import MessageItem from './messageItem';

interface IMessage {
	avatarLink: string;
	authorName: string;
	isReplier?: boolean;
	message: string;
	role: TRole;
	bought: boolean;
	createAt: string;
	children?: React.ReactNode;
}

const Message = ({
	avatarLink, authorName, role, createAt, bought, message, children, isReplier = false,
}: IMessage):JSX.Element => (
	<MessageItem
		isReplier={isReplier}
		authorName={authorName}
		role={role}
		avatarLink={avatarLink}
		createAt={createAt}
		message={message}
		bought={bought}
	>
		{children}
	</MessageItem>
);

export default Message;
